import get from 'lodash/get';
import { isTranslationFile } from "../../models";
var Translator = /** @class */ (function () {
    function Translator(translationFile) {
        this.translationFile = translationFile;
    }
    Translator.prototype.getText = function (key, params, defaultValue) {
        var template = this.getTemplateOrDefault(key, defaultValue);
        return Translator.replacePlaceholders(template, params);
    };
    Translator.prototype.getTemplateOrDefault = function (key, defaultValue) {
        var template = this.getTemplate(key);
        if (template !== undefined)
            return template;
        if (defaultValue !== undefined)
            return defaultValue;
        return "{Translation not found: ".concat(key, "}");
    };
    Translator.prototype.getTemplate = function (key) {
        var _a;
        if (isTranslationFile(this.translationFile)) {
            return (_a = this.translationFile.strings[key]) === null || _a === void 0 ? void 0 : _a.text;
        }
        // get value from TranslationFileDeprecated
        var template = get(this.translationFile, key);
        if (typeof template !== 'string')
            return undefined;
        return template;
    };
    /**
     * Replace placeholders like "{{foo}}" with the value specified in params['foo'].
     *
     * Placeholders without a value present in params are left untouched.
     */
    Translator.replacePlaceholders = function (template, params) {
        if (!params) {
            return template;
        }
        var result = template;
        Object.keys(params).forEach(function (key) {
            var reg = new RegExp("{{\\s*".concat(key, "\\s*}}"), 'g');
            result = result.replace(reg, params[key]);
        });
        return result;
    };
    return Translator;
}());
export default Translator;
//# sourceMappingURL=translations.js.map